// Single Face Swap Handler
// This handles the special processing flow for single-face-swap template

(function() {
  console.log('Single Face Swap Handler: Initializing...');
  
  // Function to process single face swap (now using Nano Banana)
  window.processSingleFaceSwap = async function(faceImageFile, targetImageBase64) {
    console.log('Processing with Nano Banana portrait generation...');
    
    try {
      // Convert face image to base64
      const faceImageBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(faceImageFile);
      });
      
      // Check if this is a Trump face swap or regular portrait
      let portraitPrompt;
      if (window.isTrumpFaceSwap && window.trumpPrompt) {
        // Use Trump-specific prompt
        portraitPrompt = window.trumpPrompt;
        console.log('Using Trump face swap prompt');
      } else {
        // Default professional portrait prompt (gender-neutral)
        portraitPrompt = "Turn this person into a black-and-white studio portrait of a young individual sitting confidently on a chair, dressed in a sleek black leather jacket layered over a dark V-neck shirt and dark trousers. They have medium-length, slightly wavy hair that frames their face and gives them a stylish, modern look. Their facial features should be kept intact and emphasized, preserving their unique identity and expression. They lean forward slightly, resting their hands casually, giving the portrait a composed yet natural presence. The overall atmosphere should feel cinematic and editorial, with soft but directional lighting that highlights the texture of the leather jacket, the contours of their hair, and the sharpness of their facial structure. The mood should capture the sophistication and boldness of high-fashion photography, with clean contrast, rich tones, and a timeless black-and-white finish that emphasizes elegance and confidence.";
        console.log('Using default portrait prompt');
      }
      
      // Strip the data URL prefix if present (Railway expects pure base64)
      let imageData = faceImageBase64;
      if (imageData.includes('base64,')) {
        imageData = imageData.split('base64,')[1];
      }
      
      // Determine aspect ratio based on template
      let aspectRatio = "3:4"; // default portrait
      let style = "portrait";
      
      // Check if horizontal aspect ratio is needed (for three-men-portrait template)
      if (window.useHorizontalAspect || window.isThreeMenPortrait) {
        aspectRatio = "4:3"; // landscape for three-men group photo
        style = "landscape";
        console.log('Using horizontal aspect ratio for three-men portrait');
      }
      
      // Prepare payload for Nano Banana API
      const payload = {
        image: imageData,
        prompt: portraitPrompt,
        aspectRatio: aspectRatio,
        style: style
      };
      
      console.log('Nano Banana payload prepared with portrait prompt');
      
      // Send to nano-banana-generate endpoint
      const baseUrl = window.baseURL || 'https://letzteshemdback.up.railway.app';
      const response = await fetch(`${baseUrl}/nano-banana-generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Nano Banana response received:', data.success ? 'Success' : 'Failed');
      
      // Handle immediate response (no polling needed)
      if (data.success && data.result) {
        // Use a generated jobId for compatibility
        const jobId = 'nano-' + Date.now();
        
        // Get the image data (might be data.result.image or just data.result)
        let imageData = data.result.image || data.result;
        
        // Add data URL prefix if missing (Railway returns raw base64)
        if (imageData && !imageData.startsWith('data:')) {
          imageData = `data:image/png;base64,${imageData}`;
        }
        
        console.log('Nano Banana image format:', imageData ? imageData.substring(0, 50) + '...' : 'null');
        
        // Store result globally for cart/checkout
        window.resultImageUrl = imageData;
        window.processedImageUrl = imageData;
        window.watermarkedImageUrlToShow = imageData;
        window.nonWatermarkResultImg = imageData;
        
        // Hide loading popup
        if (typeof window.hideLoadingPopup === 'function') {
          window.hideLoadingPopup();
        }
        
        // Display result popup
        if (typeof window.showResultPopup === 'function') {
          console.log('Showing result popup with image');
          window.showResultPopup(imageData);
        } else {
          console.error('showResultPopup function not found');
        }
        
        // Dispatch success event
        document.dispatchEvent(new CustomEvent('single-face-swap-complete', {
          detail: {
            status: 'completed',
            imageUrl: imageData,
            processedImageUrl: imageData,
            jobId: jobId
          }
        }));
        
        return {
          success: true,
          jobId: jobId,
          imageUrl: imageData
        };
      } else {
        // Handle error
        const errorMsg = data.error || 'Nano Banana generation failed';
        console.error('Nano Banana error:', errorMsg);
        
        // Hide loading popup
        if (typeof window.hideLoadingPopup === 'function') {
          window.hideLoadingPopup();
        }
        
        // Show error message
        alert(`Failed to generate image: ${errorMsg}`);
        
        throw new Error(errorMsg);
      }
      
      return data;
      
    } catch (error) {
      console.error('Error in single face swap processing:', error);
      throw error;
    }
  };
  
  // Function to process dual sibling portrait with two separate images
  window.processDualSiblingPortrait = async function(faceImageFile1, faceImageFile2) {
    console.log('Processing dual sibling portrait with Nano Banana...');
    
    try {
      // Convert both face images to base64
      const faceImageBase64_1 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(faceImageFile1);
      });
      
      const faceImageBase64_2 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(faceImageFile2);
      });
      
      // Strip the data URL prefix if present (Railway expects pure base64)
      let imageData1 = faceImageBase64_1;
      let imageData2 = faceImageBase64_2;
      
      if (imageData1.includes('base64,')) {
        imageData1 = imageData1.split('base64,')[1];
      }
      if (imageData2.includes('base64,')) {
        imageData2 = imageData2.split('base64,')[1];
      }
      
      // Use the sibling portrait prompt
      const siblingPrompt = window.trumpPrompt || "Transform these two individual photos into a Step Brothers movie style portrait. CRITICAL: Keep the exact facial features and face structure of both people - only change their clothing and styling. Apply these specific changes: - Purple/lavender dress shirts with argyle sweater vests (one burgundy, one gray/black) - Classic 80s/90s mottled blue studio portrait background - One person behind with hands on the other's shoulders - 2000s comedy movie hair styling - Soft studio lighting with that awkward family portrait vibe. The result should look like a Step Brothers promotional photo - comedic and endearingly awkward, but photorealistic. Maintain all original facial features exactly as they are.";
      
      // Prepare payload for Nano Banana API with multiple images
      const payload = {
        images: [imageData1, imageData2],  // Array of two images
        prompt: siblingPrompt,
        aspectRatio: "4:3",  // Landscape for two people
        style: "landscape",
        mode: "dual-portrait"  // Indicate this is a dual portrait mode
      };
      
      console.log('Nano Banana dual image payload prepared');
      
      // Send to nano-banana-generate endpoint with multiple images
      const baseUrl = window.baseURL || 'https://letzteshemdback.up.railway.app';
      const response = await fetch(`${baseUrl}/nano-banana-generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('Nano Banana dual image response received:', data.success ? 'Success' : 'Failed');
      
      // Handle immediate response (no polling needed)
      if (data.success && data.result) {
        // Use a generated jobId for compatibility
        const jobId = 'nano-dual-' + Date.now();
        
        // Get the image data (might be data.result.image or just data.result)
        let imageData = data.result.image || data.result;
        
        // Add data URL prefix if missing (Railway returns raw base64)
        if (imageData && !imageData.startsWith('data:')) {
          imageData = `data:image/png;base64,${imageData}`;
        }
        
        console.log('Nano Banana dual image result received');
        
        // Store result globally for cart/checkout
        window.resultImageUrl = imageData;
        window.processedImageUrl = imageData;
        window.watermarkedImageUrlToShow = imageData;
        window.nonWatermarkResultImg = imageData;
        
        // Hide loading popup
        if (typeof window.hideLoadingPopup === 'function') {
          window.hideLoadingPopup();
        }
        
        // Display result popup
        if (typeof window.showResultPopup === 'function') {
          console.log('Showing result popup with dual portrait image');
          window.showResultPopup(imageData);
        } else {
          console.error('showResultPopup function not found');
        }
        
        // Dispatch success event
        document.dispatchEvent(new CustomEvent('single-face-swap-complete', {
          detail: {
            status: 'completed',
            imageUrl: imageData,
            processedImageUrl: imageData,
            jobId: jobId,
            isDualPortrait: true
          }
        }));
        
        return {
          success: true,
          jobId: jobId,
          imageUrl: imageData
        };
      } else {
        // Handle error
        const errorMsg = data.error || 'Nano Banana dual image generation failed';
        console.error('Nano Banana error:', errorMsg);
        
        // Hide loading popup
        if (typeof window.hideLoadingPopup === 'function') {
          window.hideLoadingPopup();
        }
        
        // Show error message
        alert(`Failed to generate dual portrait: ${errorMsg}`);
        
        throw new Error(errorMsg);
      }
      
    } catch (error) {
      console.error('Error in dual sibling portrait processing:', error);
      
      // Hide loading popup
      if (typeof window.hideLoadingPopup === 'function') {
        window.hideLoadingPopup();
      }
      
      throw error;
    }
  };
  
  // Polling function is no longer needed with Nano Banana's immediate response
  // Keeping empty function for backward compatibility if called elsewhere
  async function pollSingleFaceStatus(jobId) {
    console.log('Polling not needed for Nano Banana - immediate response already handled');
  }
  
  // Override the image processing for single face swap
  document.addEventListener('DOMContentLoaded', function() {
    // Check if this is single face swap template
    const buyButtons = document.querySelector('buy-buttons');
    const templateSuffix = buyButtons ? buyButtons.getAttribute('template') : '';
    
    if (templateSuffix === 'single-face-swap') {
      console.log('Single face swap template detected - setting up handler');
      window.isSingleFaceSwap = true;
      
      // Load target image
      if (typeof window.getSingleFaceTargetImage === 'function') {
        window.getSingleFaceTargetImage().then(targetBase64 => {
          console.log('Target image loaded for single face swap');
          window.singleFaceSwapTargetBase64 = targetBase64;
        });
      }
    }
  });
  
})();